module.exports = __webpack_public_path__ + "app-static/img/face-top.0a3d3582.png";